export default __webpack_public_path__ + "static/media/problem_black.a92a5608.png";